export default {"src":"/_next/static/media/fireIcon.60dc7b42.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};